import React, { Fragment } from 'react';
import Animation from '../Questions/Steps/Animation';
import '../Questions/Steps/Animation.css';
import { Formik, FormikProps, FormikValues } from 'formik';
import * as Yup from 'yup';
import { AccountLoginState } from '../../store/account/types';
import { $Values, ValuesType } from 'utility-types';
import { FlowProps } from '../HOC/HOCProps';
import styles from './ProgressiveForm_SA.module.scss';

interface ProgressiveFormState {
    pages: any[]
    currentPage: number,
    errorMessage: React.ReactElement | null,
    mensaje: string
}

interface ProgressiveFormProps<TFormikTypeValues> {

    nextPage: any,
    previousPage: any,
    validationSchema: Yup.Schema<TFormikTypeValues>,
    initialValues: TFormikTypeValues,
    showMessage: boolean,
    component: React.ComponentType<FlowProps<TFormikTypeValues>>,
    currentStep: number
}

class ProgressiveForm<TFormikTypeValues> extends React.Component<ProgressiveFormProps<TFormikTypeValues>, ProgressiveFormState> {
    render() {
        const Component: React.ComponentType<FlowProps<TFormikTypeValues>> = this.props.component;

        return (          
                <Fragment>
                    <div className="container">
                        <div className="row justify-content-center">
                            <Formik
                                initialValues={this.props.initialValues as TFormikTypeValues}
                                validationSchema={this.props.validationSchema}
                                onSubmit={(values, { setSubmitting }) => {
                                    setTimeout(() => {
                                        alert(JSON.stringify(values, null, 2));
                                        setSubmitting(false);
                                    }, 400);
                                }}>
                                {
                                    (formikProps: FormikProps<TFormikTypeValues>) => (
                                        <div className={styles.progressiveformcontainer + " col-lg-10"}>
                                            <Animation shouldRender={this.props.showMessage}>
                                                {
                                                    <div className={styles.progressivecontainerformgrid}>
                                                        <Component
                                                            currentStep={this.props.currentStep}
                                                            nextPage={this.props.nextPage}
                                                            formikProps={formikProps as FormikProps<any>}
                                                            previousPage={this.props.previousPage}
                                                            validateResponse={() => { }}
                                                            errorMessage={null}
                                                            mensaje=""
                                                        />
                                                    </div>
                                                }
                                            </Animation>
                                        </div>
                                    )
                                }
                            </Formik>
                        </div>
                    </div>
                </Fragment>
        )

    }
}

export default ProgressiveForm;